import { render, staticRenderFns } from "./PedidoForm.vue?vue&type=template&id=5970ce80&scoped=true"
import script from "./PedidoForm.vue?vue&type=script&lang=js"
export * from "./PedidoForm.vue?vue&type=script&lang=js"
import style0 from "./PedidoForm.vue?vue&type=style&index=0&id=5970ce80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5970ce80",
  null
  
)

export default component.exports